//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
//  Styles
import '../styles/styles.scss';
// JS
import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
// import { TextPlugin } from "gsap/TextPlugin";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import Slick from './proj/slick';
import Plyr from './proj/plyr';
import moment from 'moment-timezone/builds/moment-timezone-with-data';

gsap.registerPlugin(ScrollTrigger, SplitText); 


let Site;
let breakpointSite = 768;
let timerScreensaver = null;
const touch = matchMedia('(hover: none)').matches;

(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			// self.scrollToAnchor();
			self.newWindowLink();


			if(touch) {
				$('body').addClass('is-touch-device');
			}
			else {
				$('body').addClass('is-rollover-device');
			}
			// const touch = matchMedia('(hover: none)').matches;
			// if(document.referrer == "") {
			// 	if(touch) {
			// 		// $('.cp-bg-layer, .flex-v-center:not(.h-auto) ').css('height', $(window).outerHeight());
			// 	}
			// }
			// if(touch) {
			// 	window.addEventListener('resize', () => {
			// 		// We execute the same script as before
			// 		// $('.cp-bg-layer, .flex-v-center:not(.h-auto) ').css('height', $(window).outerHeight());
			// 	});
			// }

			// Detect Safari using JavaScript
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
				$('body').addClass('is-safari');
			}

			// self.removeOrphans();
			self.progressBar();
			self.versionTabs();
			self.workTabs();
			self.loadHash();
			self.toggleTheme();
			self.screensaver();
			self.statAnimation();
			self.loazyloadImage('.wrapper-article');
			if(!touch) {
				self.cardsRollover();
			}
			self.showreelSync();
	
			document.fonts.ready.then(function () {
				self.testimonialsSlider();
				self.scrollAnimation();
				self.inviewAnimation();
				// self.countUpNumbers();
				// self.scrollRefresh();
				// self.showRelevantCTA();
				// self.scrollIndicator();
			});
			// const scroll = new LocomotiveScroll();
		},	

		
		statAnimation: function(){

			function numberWithCommas(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}

			function isInt(n) {
				return n % 1 === 0;
			}
			function isFloat(n){
				return Number(n) === n && n % 1 !== 0;
			}

			function hasDotOrComma(value) {
				return value.indexOf(".") !== -1 || value.indexOf(",") !== -1;
			}

			function hasTwoDecimals(value) {
				const parts = value.split('.');
				return parts.length === 2 && parts[1].length === 2;
			}
		
			function animateState(el) {
				const count = $(el);
				const number = count.attr("data-number");
				const prefix_val = count.attr('data-prefix') || '';
				const suffix_val = count.attr('data-suffix') || '';
				const comma = isFloat(count.attr("data-number"));
				const countUpDuration = $(el).attr('data-duration') || 1;

				let increment;
				if (hasTwoDecimals(number)) {
					increment = 0.01; // Use 0.01 for two decimals
				} else if (hasDotOrComma(number)) {
					increment = 0.1; // Use 0.1 for other decimals
				} else {
					increment = 1; // Use 1 for integers
				}

				gsap.to(count, {
					innerText: number,
					snap: { innerText: increment },
					stagger: {
						each: 1,
						onUpdate: function() {
							const targetText = parseFloat(this.targets()[0].innerText);

							// Check the number of decimal places in the final target value
							let decimalPlaces = 0;
							if (number.includes(".")) {
								decimalPlaces = number.split(".")[1].length;
							}

							// Format the number with the appropriate number of decimal places
							const formattedNumber = targetText.toFixed(decimalPlaces);
							
							// Update the innerHTML with prefix and suffix
							this.targets()[0].innerHTML = prefix_val + formattedNumber + suffix_val;
						},
					},
					duration: countUpDuration,
					ease: "none"  // Set ease to "none" for a linear transition
				});
			}

			$('.js-stat-number').each(function(el){

				const $el = $(this);
				const $el_trigger = $(this).parents('.txt-stat');

				const el_suffix = $(this).attr('data-suffix');
				const el_prefix = $(this).attr('data-prefix');

				var start_val = "top bottom";
				if($el_trigger.hasClass('start-bottom')) {
					start_val = "bottom bottom";
				}


				ScrollTrigger.create({
					trigger: $el_trigger, 
					start: start_val,
					// markers: true,
					id: "stat-view",
					onEnter: function(){
						$el.html(el_prefix+0+el_suffix);
						animateState($el);
						gsap.set($el, {opacity: 0})
						gsap.to($el, {opacity: 1, duration: 0.3})
						// if (!$el.hasClass('is-inview')) {
							// $el.addClass('is-inview');
						// }
					},
					onEnterBack: function(){
						// $('.js-stat-number').html(0);
						// animateState($el);
					},
					onLeaveBack: function(){
						gsap.to($el, {opacity: 0, duration: 0.3})
					}
				});
				
			});

		},
		testimonialsSlider: function(){
			var self = this;

			$('.js-slider').each(function(elt){
				const $sliderEl = $(this);

				var vertical_val = false;
				if($(this).hasClass('slider-vertical')){
					vertical_val = true;
				}

				const $slider = $sliderEl.slick({
					dots: false,
					arrows: false,
					infinite: false,
					draggable: false,
					swipe: false,
					verticalSwiping: false,
					vertical: vertical_val,
					// centerMode: true,
					speed: 700,
					slide: '.slide',
					slidesToScroll: 1,
					autoplay: false,
					// appendDots: parentContainer.find('.js-slider-dots'),
				});

				const $prev = $('.slider-prev');
				const $next = $('.slider-next');

				function updateNavState(currentSlide, totalSlides) {
					$prev.toggleClass('is-disabled', currentSlide === 0);
					$next.toggleClass('is-disabled', currentSlide === totalSlides - 1);
				}

				$sliderEl.on('init reInit afterChange', function (event, slick, currentSlide) {
					const current = currentSlide || 0;
					updateNavState(current, slick.slideCount);
				});

				$prev.on('click', function () {
					if (!$(this).hasClass('is-disabled')) {
						$slider.slick('slickPrev');
					}
				});

				$next.on('click', function () {
					if (!$(this).hasClass('is-disabled')) {
						$slider.slick('slickNext');
					}
				});

				// $slider.slick('refresh');

			});

		},
		screensaver: function(){

			if(!touch) {

				function startTimerScreensaver() {  
					// $('aside.screensaver').removeClass('show');
					if (timerScreensaver != null) {
						window.clearTimeout(timerScreensaver); 
						timerScreensaver = null;
					}
					else {
						timerScreensaver = setTimeout(function(){
							$('aside.screensaver').addClass('show');
							// $('.icon-omse').addClass('forceWhite');
						}, 1000*60*2);
					}
				}
				$('aside.screensaver').on('click', function(){
					$('aside.screensaver').removeClass('show');
					// $('.icon-omse').removeClass('forceWhite');
					setTimeout(function(){
						startTimerScreensaver();
					}, 500);
				});

				// 	window.addEventListener('mousemove', resetIdleTimer);
				// 	window.addEventListener('mousedown', resetIdleTimer);
				// 	window.addEventListener('touchstart', resetIdleTimer);
				// 	window.addEventListener('keydown', resetIdleTimer);
				// 	window.addEventListener('scroll', resetIdleTimer);

				$(document).bind( "mousemove keydown scroll touchstart click", function () {
					window.clearTimeout(timerScreensaver);
					setTimeout(function(){

						startTimerScreensaver();
					}, 500);
				});
				startTimerScreensaver();

				function updateTime() {
					setTimeout(function(){
						$('#ny-time').html( moment().tz("America/New_York").format('HH:mm:ss') );
						$('#london-time').html( moment().tz("Europe/London").format('HH:mm:ss') );
						$('#hk-time').html( moment().tz("Asia/Hong_Kong").format('HH:mm:ss') );
						// call the function again every minutes
						updateTime();
					}, 1000);
				}
				updateTime();
			}

		},
		workTabs: function(){
			var self = this; 
			$('.section-work .project-types a').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				
				const id = $(this).attr('href');

				history.pushState(null,null,id);

				$('.section-work .content-type').removeClass('is-visible');
				$('.section-work .project-types a.is-active').removeClass('is-active');


				$(this).addClass('is-active');
				$(id).parent().addClass('is-visible');

				var elts = $('.section-work .content-type.is-visible ul').children();

				ScrollTrigger.refresh();

				gsap.set(elts, {opacity: 0, x: -15});
				gsap.to(elts, {opacity: 1, x: 0, stagger: 0.05, duration: 0.4, overwrite: true});
			});
		},

		/**
		 * Showreel: mirrors the currently-playing project below the video
		 * (driven by Plyr's `timeupdate`), then reveals the full project
		 * list once the reel finishes, per its `ended` event.
		 *
		 */
		showreelSync: function(){
			if (!$('.page-showreel').length || typeof Plyr === 'undefined') return;

			// Self-hosted video, not Vimeo: `timeupdate` comes straight from
			// the browser's own media engine instead of a cross-iframe
			// postMessage round-trip, so the project sync tracks tighter.
			// `pip` dropped from controls and `speed` from the settings menu:
			// neither is relevant for a short autoplaying showreel loop.
			const player = new Plyr('#js-showreel-player', {
				controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'airplay', 'fullscreen'],
				settings: ['captions', 'quality', 'loop']
			});

			const $frame = $('.js-showreel-frame');
			const $overlay = $('.js-showreel-overlay');
			const $playBtn = $('.js-showreel-play');
			const $items = $('.showreel-list__item');
			const $now = $('#js-showreel-now');
			let activeIndex = -1;

			// Vanishes the overlay title + "Play showreel" trigger before handing
			// off to the video. Built as a reusable timeline (rather than a
			// one-shot tween) so it plays cleanly every time it's restarted.
			const overlayTl = gsap.timeline({paused: true})
				.to($playBtn, {opacity: 0, y: -6, duration: 0.25, ease: 'power2.in'})
				.to($overlay.find('.showreel__overlay-title, .showreel__overlay-copy'), {opacity: 0, y: -6, duration: 0.25, ease: 'power2.in'}, '<0.05')
				.to($overlay, {opacity: 0, duration: 0.2}, '<');

			function playShowreel(){
				activeIndex = -1;
				overlayTl.restart();
				$frame.addClass('is-playing');
				player.play();
			}

			$overlay.on('click', playShowreel);

			// Pauses playback once the frame has fully scrolled out of the
			// viewport (either direction), so the showreel doesn't keep
			// playing to an empty screen while the visitor reads elsewhere
			// on the page.
			ScrollTrigger.create({
				trigger: $frame[0],
				start: 'top bottom',
				end: 'bottom top',
				onLeave: function(){ player.pause(); },
				onLeaveBack: function(){ player.pause(); }
			});

			const $overlayTitle = $('.js-showreel-title');
			const self = this;

			// Character-level split for the overlay title's weight-rollover
			// hover effect, deferred until the custom font is actually
			// loaded (splitting against the fallback system font first gives
			// wrong char boxes once the real font swaps in). Chars only (no
			// "lines"/"words"), unlike `.st-line-once` elsewhere, since
			// grouping into lines depends on the container's width at split
			// time, which is unstable for an absolutely-positioned overlay
			// title and was stacking one word per line intermittently.
			document.fonts.ready.then(function(){
				if ($overlayTitle.length) {
					new SplitText($overlayTitle, {type: 'chars', charsClass: 'wght-char'});
					self.charWeightRollover($overlayTitle[0]);
				}
			});

			// Cursor-follow "Play showreel" label, desktop only. The button
			// stays a real, statically-centered control on touch devices.
			if (!touch) {

				// Anchored to the copy line when present, since it sits below
				// the title — using the title alone here made the button's
				// rest position land on top of the copy instead of below it.
				const $overlayAnchor = $overlay.find('.showreel__overlay-copy').length
					? $overlay.find('.showreel__overlay-copy')
					: $overlayTitle;

				function restPosition(){
					const frameRect = $frame[0].getBoundingClientRect();
					const anchorRect = $overlayAnchor[0].getBoundingClientRect();
					// Clamped so it can't spill past the frame's own bottom
					// edge on short frames (eg. a 2-line copy on mobile).
					const y = Math.min((anchorRect.bottom - frameRect.top) + 24, frameRect.height - 24);
					return {
						x: frameRect.width / 2,
						y: y
					};
				}

				// Two nested rAFs, not fonts.ready: the frame's own width
				// comes from viewport units, nothing font-dependent, but
				// measuring it synchronously on init could still land before
				// the browser has committed a layout pass for this frame
				// (reads back as a zero-size box). Waiting two animation
				// frames guarantees at least one full layout/paint has
				// happened first.
				requestAnimationFrame(function(){
					requestAnimationFrame(function(){
						const rest = restPosition();
						gsap.set($playBtn, {xPercent: -50, yPercent: -50, x: rest.x, y: rest.y});
					});
				});

				const followX = gsap.quickTo($playBtn, 'x', {duration: 0.45, ease: 'power3'});
				const followY = gsap.quickTo($playBtn, 'y', {duration: 0.45, ease: 'power3'});

				// Offset from the actual pointer tip so the cursor arrow
				// itself doesn't sit directly over the "Play showreel" text.
				const CURSOR_OFFSET_X = 0;
				const CURSOR_OFFSET_Y = 32;

				$frame.on('mousemove', function(e){
					const rect = this.getBoundingClientRect();
					followX(e.clientX - rect.left + CURSOR_OFFSET_X);
					followY(e.clientY - rect.top + CURSOR_OFFSET_Y);
				});

				$frame.on('mouseleave', function(){
					// Reuses the same quickTo setters as mousemove, rather than a
					// separate gsap.to(): quickTo caches its own tween per
					// property, and an unrelated gsap.to() on that same
					// property (even with overwrite) breaks that cached tween,
					// silently stopping the follow from working the next time
					// the cursor re-enters.
					const r = restPosition();
					followX(r.x);
					followY(r.y);
				});
			}

			const $category = $('.js-showreel-category');
			const $counter = $('.js-showreel-counter');
			const itemCount = $items.length;

			// Crossfades a single label's text: fades out whatever text is
			// currently there, swaps it, fades the new text in. Used for the
			// category/counter labels, which are plain text (unlike the
			// multi-child "now playing" panel below).
			function crossfadeText($el, text){
				gsap.to($el, {opacity: 0, y: -4, duration: 0.16, ease: 'power2.in', overwrite: true, onComplete: function(){
					$el.text(text);
					gsap.fromTo($el, {opacity: 0, y: 4}, {opacity: 0.6, y: 0, duration: 0.4, ease: 'power2.out'});
				}});
			}

			// Same crossfade, but swaps markup instead of a plain string —
			// used for the category label so the type/client can each sit in
			// their own span and break onto a fixed second line on mobile
			// instead of wrapping mid-phrase wherever the words happen to run out.
			function crossfadeHtml($el, html){
				gsap.to($el, {opacity: 0, y: -4, duration: 0.16, ease: 'power2.in', overwrite: true, onComplete: function(){
					$el.html(html);
					gsap.fromTo($el, {opacity: 0, y: 4}, {opacity: 0.6, y: 0, duration: 0.4, ease: 'power2.out'});
				}});
			}

			// Mirrors the currently-playing project below the video (title +
			// link), and the category/counter labels above it — all three
			// change together on every `activate()`. Only the "now playing"
			// panel's own children fade in/out; `$now` itself is never
			// faded, since a hidden parent hides its children too, no
			// matter what opacity those children later animate to.
			function renderNow(index){
				const $item = $items.eq(index);
				const meta = $item.find('.showreel-list__meta').text();
				const client = $item.find('.showreel-list__client').text();
				const title = $item.find('.showreel-list__title').html();
				const link = $item.find('.showreel-list__icon').attr('href');

				const categoryHtml = '<span class="showreel__meta-bar-type">' + meta + '</span>'
					+ (client
						? '<span class="showreel__meta-bar-sep"> - </span><span class="showreel__meta-bar-client">' + client + '</span>'
						: '');
				crossfadeHtml($category, categoryHtml);
				crossfadeText($counter, (index + 1) + ' / ' + itemCount);

				const html = '<span class="showreel-now__title">' + title + '</span>'
					+ (link
						? '<a class="showreel-now__link" href="' + link + '" target="_blank" rel="noopener"><span>View the project</span><svg xmlns="http://www.w3.org/2000/svg" width="14" viewBox="0 0 30 30" class="fill"><path d="M 25.980469 2.9902344 A 1.0001 1.0001 0 0 0 25.869141 3 L 20 3 A 1.0001 1.0001 0 1 0 20 5 L 23.585938 5 L 13.292969 15.292969 A 1.0001 1.0001 0 1 0 14.707031 16.707031 L 25 6.4140625 L 25 10 A 1.0001 1.0001 0 1 0 27 10 L 27 4.1269531 A 1.0001 1.0001 0 0 0 25.980469 2.9902344 z M 6 7 C 4.9069372 7 4 7.9069372 4 9 L 4 24 C 4 25.093063 4.9069372 26 6 26 L 21 26 C 22.093063 26 23 25.093063 23 24 L 23 14 L 23 11.421875 L 21 13.421875 L 21 16 L 21 24 L 6 24 L 6 9 L 14 9 L 16 9 L 16.578125 9 L 18.578125 7 L 16 7 L 14 7 L 6 7 z"></path></svg></a>'
						: '<span class="showreel-now__offline">Project offline - on request</span>');

				function swapAndReveal(){
					$now.html(html);
					gsap.fromTo($now.children(), {opacity: 0, y: 10}, {opacity: 1, y: 0, duration: 0.4, stagger: 0.06, ease: 'power2.out', overwrite: true});
				}

				// `$now.children()` must be queried fresh *after* the fade-out
				// finishes and the HTML is swapped, not up front — GSAP resolves
				// tween targets immediately when the tween is created, so
				// building this as one pre-declared timeline animated the
				// about-to-be-removed old elements while the new ones (swapped
				// in later by a `.call()`) never got their opacity touched.
				if ($now.children().length) {
					gsap.to($now.children(), {opacity: 0, y: 6, duration: 0.16, ease: 'power2.in', overwrite: true, onComplete: swapAndReveal});
				}
				else {
					swapAndReveal();
				}
			}

			function activate(index){
				if (index === activeIndex || index < 0) return;
				activeIndex = index;
				renderNow(index);
			}

			// Swaps the project copy (and fades out the category/counter
			// labels) for a "Say hi" prompt once the last project's card
			// closes, rather than waiting for the video's own `ended` event:
			// the footage runs to 60s, but the last project is done at 54s,
			// so waiting for true `ended` left a few seconds of dead air
			// before the prompt appeared. The video itself is left alone
			// otherwise: it's self-hosted (not Vimeo), so it just settles on
			// its own real last frame with no branded overlay to hide.
			let finished = false;
			const lastItemEnd = parseFloat($items.last().attr('data-end'));

			function finish(){
				if (finished) return;
				finished = true;

				gsap.to([$category, $counter], {opacity: 0, y: -4, duration: 0.3, ease: 'power2.in'});

				function swapToSayHi(){
					$now.html('<a href="#js-footer-contact" class="showreel-now__sayhi js-showreel-sayhi">Get in touch</a>');
					gsap.fromTo($now.children(), {opacity: 0, y: 10}, {opacity: 1, y: 0, duration: 0.4, ease: 'power2.out'});
				}

				if ($now.children().length) {
					gsap.to($now.children(), {opacity: 0, y: 6, duration: 0.16, ease: 'power2.in', overwrite: true, onComplete: swapToSayHi});
				}
				else {
					swapToSayHi();
				}
			}

			$now.on('click', '.js-showreel-sayhi', function(e){
				e.preventDefault();
				const target = document.getElementById('js-footer-contact');
				if (target) target.scrollIntoView({behavior: 'smooth'});
			});

			player.on('timeupdate', function(){
				const t = player.currentTime;

				if (t >= lastItemEnd) {
					finish();
					return;
				}

				$items.each(function(i){
					const start = parseFloat($(this).attr('data-start'));
					const end = parseFloat($(this).attr('data-end'));
					if (t >= start && t < end) activate(i);
				});
			});

			// Fallback in case the file ever runs shorter than lastItemEnd.
			player.on('ended', finish);
		},

		cardsRollover: function(){

			const container = document.querySelector('.cards');
			if (!container) return;

			const containerW = container.clientWidth;

			const cards = document.querySelectorAll('.card');
			const cardsLength = cards.length;

			const cardContent = document.querySelectorAll('.card .content');

			let currentPortion = 0 // No portion hovered at the start

			cards.forEach(card => {
				gsap.set(card, {
					xPercent: (Math.random() - 0.5) * 10,
					yPercent: (Math.random() - 0.5) * 10,
					rotation: (Math.random() - 0.5) * 20,
				})
			})

			container.addEventListener("mousemove", e => {
				// Cursor position relative to the left edge of the container
				const mouseX = e.clientX - container.getBoundingClientRect().left
				// Cursor’s horizontal percentage within the container
				const percentage = mouseX / containerW
				// Round the value up to get a valid index
				const activePortion = Math.ceil(percentage * cardsLength)
				
				// If a new portion is hovered
				if(
					currentPortion !== activePortion &&
					activePortion > 0 &&
					activePortion <= cardsLength
				){
					// If a portion was already hovered, reset it
					// -1 to target the correct index in the card set
					if(currentPortion !== 0){ resetPortion(currentPortion - 1) }

					// Update the index of the new portion
					currentPortion = activePortion
					// -1 to target the correct index in the card set
					newPortion(currentPortion - 1)
				}
			})

			container.addEventListener("mouseleave", () => {
				// -1 to target the correct index in the card set
				resetPortion(currentPortion - 1)
				// No portion is hovered anymore
				currentPortion = 0

				// Recenter all direct child elements of the cards
				gsap.to(cardContent, {
					xPercent: 0,
					ease:'elastic.out(1, 0.75)',
					duration:0.8
				})
			})

			function resetPortion(index) {
				// Last active card
				gsap.to(cards[index], {
					xPercent: (Math.random() - 0.5) * 10,
					yPercent: (Math.random() - 0.5) * 10,
					rotation: (Math.random() - 0.5) * 20,
					scale:1,
					duration:0.8,
					ease:'elastic.out(1, 0.75)',
				})
			}

			function newPortion(i) {
				gsap.to(cards[i], {
					// Reset transformation attributes
					xPercent:0,
					yPercent:0,
					rotation:0,
					duration:0.8,
					scale:1.1,
					ease:'elastic.out(1, 0.75)' // Elastic movement at the end (out)
				})

				// For each card's child element
				cardContent.forEach((cardContent, index) => {
					// If it's not the active card
					if(index !== i){
						gsap.to(cardContent, {
							// When index - i < 0, push left
							// When index - i > 0, push right
							// The further (index - i) moves from 0 in both ways, the smaller the displacement
							xPercent: 80 / (index - i),
							ease:'elastic.out(1, 0.75)',
							duration:0.8
						})
					// If it is the active card
					}else{
						// Center its child
						gsap.to(cardContent, {
							xPercent: 0,
							ease:'elastic.out(1, 0.75)',
							duration:0.8
						})
					}
				})
			}

		},
		versionTabs: function(){
			var self = this; 
			$('.versions-wrapper').css('min-height', $('.version-list').height());

			$('.text-version-switch a').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				
				const id = $(this).attr('href');

				window.addEventListener('resize', () => {
					$('.versions-wrapper').css('min-height', $('.version-list').height());
				});
				// history.pushState(null,null,id);

				$('.section-how-i-work .version').removeClass('is-visible');
				$('.section-how-i-work .text-version-switch .is-active').removeClass('is-active');


				$(this).parent().addClass('is-active');
				
				if(id == "#technical-version"){
					$('.version-list').addClass('technical');
				}
				else {
					$('.version-list').removeClass('technical');
				}

				// var elts = $('.section-work .content-type.is-visible ul').children();

				ScrollTrigger.refresh();

				// gsap.set(elts, {opacity: 0, x: -15});
				// gsap.to(elts, {opacity: 1, x: 0, stagger: 0.05, duration: 0.4, overwrite: true});

				// self.workPreload();
			});
		},
		loadHash: function(){
			// Get the hash from the URL
			const hash = window.location.hash; 
			// const hash_id = window.location.hash.substring(-1); 

			// Check if the hash matches one of the keys in the greetings object

			if ($(hash).length > 0) {
				$('.section-work .project-types a[href="'+hash.trim()+'"]').trigger('click');
			}
		},
		progressBar: function(){

			ScrollTrigger.create({
				trigger: '.wrapper-article', 
				scrub: true,
				start: "top top",
				end: "bottom bottom",
				onUpdate: (self) => {
					let percentageScrolled = self.progress * 100; // value 0 → 100
					$('.progress-bar span').css('width', percentageScrolled + '%');
				}
			});
		},
		toggleTheme: function(){
			$('.js-toggle-theme').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();

				gsap.set('.theme-overlay', {height: 0, opacity: 1});

				// gsap.timeline()
				// 	.to('.theme-overlay', {height: '100%', duration: 0.5})
				// 	.call(function(){
				// 		$('html').toggleClass('theme--light');
				// 	})
				// 	.to('.theme-overlay', {opacity: '0', duration: 0})
				$('html').toggleClass('theme--light');

				if($('html').hasClass('theme--light')) {
					$('.js-toggle-theme em').html('Switch to Dark Mode');
				}
				else {
					$('.js-toggle-theme em').html('Switch to Light Mode');
				}
			})
		},
		removeOrphans: function(){
			// remove orphans / widows 
			$('.js-greeting, .wnw').each(function() {
				const text = $(this).html();
				const words = text.split(' ');
				const totalWords = words.length;

				if(!$(this).parents().hasClass('dont-apply-words-nowrap')) {

					// Ensure there are at least 2 words
					if (totalWords >= 2) {
						const formattedLastWords = `<span class="words-nowrap">${words[totalWords - 2]} ${words[totalWords - 1]}</span>`;
						const newText = text.substring(0, text.length - (words[totalWords - 2].length + words[totalWords - 1].length + 1)) + formattedLastWords;
						$(this).html(newText);
					}
				}
			});
		},


		// scrollIndicator: function() {
		// 	const IDLE_TIMEOUT = 7000; // Milliseconds (change this to 5000 for 5 seconds)
		// 	let idleTimer;

		// 	var $indicator = $('.fixed-scroll-indicator');

		// 	function resetIdleTimer() {
		// 		$indicator.attr('data-visible','0');
		// 	  	clearTimeout(idleTimer);
		// 	  	idleTimer = setTimeout(handleInactivity, IDLE_TIMEOUT);
		// 	}

		// 	function handleInactivity() {
		// 	  	// User has been inactive for 5 seconds
		// 	  	$indicator.attr('data-visible','1');
		// 	}

		// 	function stopInactivityDetection() {
		// 	  	clearTimeout(idleTimer);
		// 	  	// You can optionally remove event listeners here if needed
		// 	}

		// 	// Attach event listeners to capture user interactions
		// 	window.addEventListener('mousemove', resetIdleTimer);
		// 	window.addEventListener('mousedown', resetIdleTimer);
		// 	window.addEventListener('touchstart', resetIdleTimer);
		// 	window.addEventListener('keydown', resetIdleTimer);
		// 	window.addEventListener('scroll', resetIdleTimer);

		// 	// Add event listener for user leaving the page (beforeunload)
		// 	window.addEventListener('beforeunload', stopInactivityDetection);

		// 	// Call resetIdleTimer on page load to start the timer
		// 	resetIdleTimer();


		// 	ScrollTrigger.create({
		// 		trigger: '.client-footer', 
		// 		scrub: true,
		// 		start: "top bottom",
		// 		onEnter: function(){
		// 			$indicator.find('i').hide();
		// 		},
		// 		onLeaveBack: function(){
		// 			$indicator.find('i').show();
		// 		},
		// 	});

		// },
		debounce: function (func, wait, immediate) {
			var timeout;
			return function() {
				var context = this, args = arguments;
				var later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},

		// Spotlight weight effect: characters get bolder the closer the cursor gets to
		// them (variable-font weight axis), based on raw cursor-to-letter distance rather
		// than word boundaries, so the bold area reads as one continuous field around the
		// cursor. Used on the hero title and the big pull-quotes. Chars ease back to their
		// thin resting weight as the cursor moves away.
		charWeightRollover: function(elt, radius){
			if (touch) return;

			const chars = elt.querySelectorAll('.wght-char');
			if (!chars.length) return;

			let minWeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--thin-weigth')) || 100;
			const maxWeight = 900;
			radius = radius || 180; // px of influence around the cursor
			const ease = 0.18; // lerp factor per frame

			const state = Array.prototype.map.call(chars, function(){
				return { current: minWeight, target: minWeight };
			});

			let mouseX = 0, mouseY = 0, active = false, rafId = null;

			function tick(){
				let settled = true;

				for (let i = 0; i < chars.length; i++) {
					let target = minWeight;
					if (active) {
						const rect = chars[i].getBoundingClientRect();
						const cx = rect.left + rect.width / 2;
						const cy = rect.top + rect.height / 2;
						const dist = Math.hypot(mouseX - cx, mouseY - cy);
						const proximity = Math.max(0, 1 - dist / radius);
						target = minWeight + (maxWeight - minWeight) * proximity;
					}
					state[i].target = target;
					state[i].current += (state[i].target - state[i].current) * ease;

					if (Math.abs(state[i].current - minWeight) > 0.5 || active) settled = false;
					chars[i].style.fontVariationSettings = "'wght' " + Math.round(state[i].current);
				}

				rafId = settled ? null : requestAnimationFrame(tick);
			}

			function ensureLoop(){
				if (rafId === null) rafId = requestAnimationFrame(tick);
			}

			elt.addEventListener('mousemove', function(e){
				// re-read in case the theme (and its base weight) was toggled since setup
				minWeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--thin-weigth')) || minWeight;
				mouseX = e.clientX;
				mouseY = e.clientY;
				active = true;
				ensureLoop();
			});
			elt.addEventListener('mouseleave', function(){
				active = false;
				ensureLoop();
			});
		},

		scrollAnimation: function (section) {
			var self = this;
			
			// ScrollTrigger.create({
			// 		trigger: '.hero',
			// 		scrub: true,
			// 		pin: true,
			// 		// anticipatePin: true,
			// 		start: "top 0",
			// 		end: "100%",
			// 		pinSpacing: false,
			// 	});

			// const split = new SplitText('.h1 strong', { type: 'words' });
			// gsap.set(split.words, {opacity: 0});
			// gsap.set('.h1 strong', {opacity: 1});

			// var title = gsap.timeline()
			// 				.from('.h1 i', {width: 10, duration:1})
			// 				.to('.h1 .line--1 .reverse', {yPercent: 100, duration:1})
			// 				.to('.h1 .line--2 .reverse', {yPercent: -100, duration:1}, '<')
			// 				.to('.h1 .line--1 .normal', {top: 0, duration:1}, '<')
			// 				.to('.h1 .line--2 .normal', {top: 0, duration:1}, '<')
			// 				// .to('.h1 ', {color: '#FBF5E9', duration:0.4}, '<')
			// 				// .to('.h1 strong', {opacity: 1, duration:1})
			// 				.to(
			// 				  split.words, // We are now targeting the words array created by SplitText
			// 				  {
			// 				    opacity: 1,
			// 				    stagger: 0.5, // Delay between each word animation
			// 				    duration: 0.5, // Duration of each fade-in
			// 				  }
			// 				)
			// 				// .to('.hero__inner', {height: '80vh', duration:.7})
			// 				.add(function(){
			// 					$('.hero__inner').addClass('reduced')
			// 				})

			
			// const creativeyear = new SplitText('.creative-year', { type: 'words' });

			// const copyElement = $('.l1');
			// const reversedText = $('.l2');

			// $('.creative-year').each(function() {
			// 	const $triggerElt = $(this);
			// 	ScrollTrigger.create({
			// 		trigger: $triggerElt,
			// 		scrub: true,
			// 		pin: true,
			// 		// anticipatePin: true,
			// 		start: "end 50%",
			// 		end: "100%",
			// 		// pinSpacing: false,
			// 		animation: 
			// 			gsap.timeline().to(creativeyear.words, {
			// 			    color: '#26538A',   // Slightly scale up the words
			// 			    y: -10,       // Move the words up to simulate a "jump"
			// 			    duration: 0.3, // Duration of the jump effect
			// 			    stagger: 0.1  // Stagger the jump effect for each word
			// 		  	})
			// 		  	.to(creativeyear.words, { opacity: 1, duration: .4})
			// 		  	.to(creativeyear.words, { opacity: 0, duration: 1})
			// 			// .to(copyElement, {
			// 			//   duration: 1,
			// 			//   rotationX: 90,  // Flip the element 180 degrees						
			// 			// })

			// 	});
			// });

			


			// ScrollTrigger.create({
			// 	trigger: '.sticky-1',
			// 	scrub: true,
			// 	pin: true,
			// 	// markers: true,
			// 	anticipatePin: true,
			// 	start: "top top",
			// 	end: "bottom top",
			// 	// pinSpacing: false,
			// 	onEnter: function(){
			// 		gsap.to($('.sticky-1').find('.txt-sticky-left'), {color: '#26538A', duration:0.3})
			// 	},
			// 	onLeaveBack: function(){
			// 		gsap.to($('.sticky-1').find('.txt-sticky-left'), {color: 'transparent', duration:0.3})
			// 	}
			// });


			// ScrollTrigger.create({
			// 	trigger: '.c-container',
			// 	scrub: true,
			// 	pin: true,
			// 	markers: true,
			// 	anticipatePin: true,
			// 	start: "top top",
			// 	end: "100%",

			// });

			// var start_top_val = 'top 0';

			ScrollTrigger.create({
				trigger: '.js-show-tagline',
				scrub: true,
				// markers: true,
				start: 'bottom 20px',
				// end: "10%",
				// animation: gsap.timeline().to(elt_p, {yPercent: 0, opacity: 1, duration:1 })
				onEnter: function(){
					$('.frame-wrapper').addClass('show-tagline');
				},
				onLeaveBack: function(){
					$('.frame-wrapper').removeClass('show-tagline');
				}
			});  
				

			$('.txt-anim-write').each(function(){

				var copy = $(this);
				let gsapReveal = new SplitText(copy, { type: "words, chars" });

				let copy_anim = gsap.timeline({paused: true})
								.to(gsapReveal.chars, {duration: 0.3, opacity:1, ease: "power", stagger: 0.005})

				gsap.set(gsapReveal.chars, {opacity: 0.3});

				gsap.set(copy, {opacity: 0});
				// play quote intro
				ScrollTrigger.create({
					trigger: copy,
					scrub: true,
					start: "top 90%", 
					end: "top 70%",
					animation: gsap.to(copy, {opacity: 1, duration: 1}),
					onEnter: () => copy_anim.play(),
					onLeaveBack: () => copy_anim.reverse(),
				})
			});

			$('.txt-anim-fade').each(function(){

				var copy = $(this);
				
				gsap.set(copy, {opacity: 0});

				// play quote intro
				ScrollTrigger.create({
					trigger: copy,
					scrub: true,
					start: "top 90%", 
					end: "top 70%",
					animation: gsap.to(copy, {opacity: 1, duration: 1})
				})
			});

			$('.st-line-once').each(function(){
				const elt = $(this);

				// for miscalcultation hide copy				
				// gsap.set(elt, {opacity: 0});

				let gsapChars = new SplitText(elt, { type: "lines,words,chars", linesClass: "lineChild", wordsClass: "h1-word", charsClass: "wght-char" });

				const words = gsapChars.words;
				var tl_title = gsap.timeline()
					.from(words, {duration: 0.5, yPercent: 120, rotation: 5, ease: "power", stagger: 0.02})
					.from('.intro-copy', {opacity: 0, duration: 1})

				self.charWeightRollover(elt[0]);
			});

			$('.st-line').each(function(){
				const elt = $(this);

				// for miscalcultation hide copy				
				// gsap.set(elt, {opacity: 0});

				let gsapChars = new SplitText(elt, { type: "lines,words,chars", linesClass: "lineChild", charsClass: "wght-char" });

				const words = gsapChars.words;

				var tl_title = gsap.timeline({paused: true});
				tl_title.from(words, {duration: 0.5, yPercent: 120, rotation: 5, ease: "power", stagger: 0.02})
					// .add(function() {
					// 	elt.addClass('played');
					// });


				// tl_title.delay(delay_val); 
				ScrollTrigger.create({
					trigger: elt,
					// scrub: true,
					anticipatePin: 1,
					// markers: true,
					start: "top 95%",
					toggleActions: "play reverse play reverse",
					animation: tl_title,
					// onEnter: function(){
					// 	// for miscalcultation show copy
					// 	// gsap.set(elt, {opacity: 1});

					// 	// tl_title.play();
					// },
					// onLeaveBack: function(){
					// 	// tl_title.reverse();
					// }
				});  

				self.charWeightRollover(elt[0]);

			});


			$('.js-anim-children--fade, .txt-anim-children').each(function(){
				const elts = $(this).children();

				// Create a timeline for this container
				const tl = gsap.timeline({ paused: true })
					.fromTo(elts, 
						{ y: 10, opacity: 0 },
						{ y: 0, opacity: 1, stagger: 0.25, duration: 0.5, ease: "power2.out" }
					);

				ScrollTrigger.create({
					trigger: this,
					scrub: true,
					start: "top 90%",
					end: "top 70%",
					toggleActions: "play reverse play reverse", // ensures smooth play/reverse
					animation: tl
				});
			});


		},

		/**
		 * inview animation
		 *
		 */
		inviewAnimation: function(){
			$("[class*='ivanim-']").each(function(){
				const $el = $(this);

				ScrollTrigger.create({
					trigger: $el, 
					id: "inview",
					start: "top bottom",
					onEnter: function(){
						if (!$el.hasClass('is-inview')) {
							$el.addClass('is-inview');
						}
					}
				});
			});

			// inview repeat
			$("[class*='ivanimr-']").each(function(){
				const $el = $(this);

				var start_val = "top bottom";
				if($el.hasClass('start-bottom')) {
					start_val = "bottom bottom";
				
					ScrollTrigger.create({
						trigger: $el, 
						start: start_val,
						onEnter: function(){
							if (!$el.hasClass('is-inview')) {
								$el.addClass('is-inview');
							}
						},
					});
					ScrollTrigger.create({
						trigger: $el, 
						start: 'top bottom',
						onLeaveBack: function(){ 
							if ($el.hasClass('is-inview')) {
								$el.removeClass('is-inview');
							}
						},
					});
				}
				else {
					ScrollTrigger.create({
						trigger: $el, 
						start: start_val,
						onEnter: function(){
							if (!$el.hasClass('is-inview')) {
								$el.addClass('is-inview');
							}
						},
						onLeave: function(){ 
							// if ($el.hasClass('is-inview')) {
							// 	$el.removeClass('is-inview');
							// }
						},
						onEnterBack: function(){ 
							// if (!$el.hasClass('is-inview')) {
							// 	$el.addClass('is-inview');
							// }
						},
						onLeaveBack: function(){ 
							if ($el.hasClass('is-inview')) {
								$el.removeClass('is-inview');
							}
						},
					});
				}

			});

			$('.js-anim-children--slidefade').each(function(){
				var elts = $(this).children();
				gsap.set(elts, {y: 30, opacity: 0});

				ScrollTrigger.batch(elts, {
					start: "top 90%",
					onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true, duration: 1.2})},
				});
			})


		},
		

		/**
		 * loazyload Image
		 *
		 */
		loazyloadImage: function (section) {
			function loadImage($this){
				if($this.length > 0) {
					if(!$this.parent().hasClass("loaded")) {
						// $this.parent().find('source').attr('srcset', $this.parent().find('source').attr('data-srcset'));
						$this.attr("srcset", $this.attr("data-srcset"));
						$this.attr("src", $this.attr("data-src"));
						$this.on('load', function() { 
							$this.parent().addClass("loaded");
						})
						.on('error', function() { console.log("error loading image"); })
						// Remove it from the set of matching elements in order to avoid that the handler gets re-executed
					}
				}
			}

			$(section+" .lazyload").each(function() {
				var $this = $(this);
				// desktop batch load section images as inview buggy with the 3d panels
				if($(window).width() >= breakpointSite) {
					loadImage($this);
				}
				else {
					// on mobile we can load in view only
					// $(this).on("inview",  function() {
					loadImage($this);
					// })
				}
			});
		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {

			// Select all elements containing the URL (e.g., anchor tags with href attribute)
			$('[href*="\\_"]').each(function() {
				// Get the current URL from the element
				var url = $(this).attr('href');

				// Replace the double underscore with a single underscore using regex
				var fixedUrl = url.replace(/\\_/g, "_");

				// Update the element's href attribute with the fixed URL
				$(this).attr('href', fixedUrl);
			});


			$('a[href]').not('.samewindow').each(function() {
				$(this).attr('target','_blank');
			});
		},

	};

	$(document).ready( function(){
		Site.init();
	})

})($);



// WEBPACK FOOTER //
// ./src/js/main.js